import { render, staticRenderFns } from "./PositiveFormality.vue?vue&type=template&id=61c3d911&scoped=true"
import script from "./PositiveFormality.vue?vue&type=script&lang=js"
export * from "./PositiveFormality.vue?vue&type=script&lang=js"
import style0 from "./PositiveFormality.vue?vue&type=style&index=0&id=61c3d911&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c3d911",
  null
  
)

export default component.exports